<adapt-collapsible-search-row #row
                              [result]="result"
                              [matches]="matches"
                              [href$]="href$">
    <div class="d-flex flex-grow-1 align-items-center justify-content-between">
        <div class="d-flex flex-grow-0 align-items-center me-2 text-muted">
            <div class="d-flex align-items-center result-icon"
                 [adaptTooltip]="BullseyeViewOption.text">
                <i [ngClass]="BullseyeViewOption.iconClass"
                   class="fa-inverse"></i>
            </div>
        </div>

        <div class="flex-grow-1 text-break d-flex align-items-center">
            {{ BullseyeViewOption.text }}
        </div>
    </div>
</adapt-collapsible-search-row>
